import { Layout as AntLayout } from 'antd';
import { usePermissions, useUserContext } from 'features/users';
import { useWindowSize } from 'hooks';
import { FileLock, FileText, Folder, House, Users } from 'lucide-react'; // Importing Lucide icons
import { useSideBar } from 'providers/side-bar-provider';
import { useEffect, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { SideBarWrapper, StyledMenu } from './side-bar.styles';
import { getActiveKeys } from './utils';
export const SideBar = () => {
  const { collapsed, toggleCollapsed } = useSideBar();
  const { isMobile } = useWindowSize();
  const location = useLocation();
  const permissions = usePermissions();
  const { menuItem }: any = useUserContext();
  const { Sider } = AntLayout;

  useEffect(() => {
    const closeMobileMenu = () => {
      if (isMobile && !collapsed) {
        toggleCollapsed();
      }
    };
    closeMobileMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const activeKeys = useMemo(
    () => getActiveKeys(location.pathname),
    [location.pathname],
  );

  if (!permissions) return null;

  const iconMap: { [key: string]: React.ReactNode } = {
    'management-report': <FileText />,
    documents: <Folder />,
    'legal-documents': <FileLock />,
    'user-management': <Users />,
    // 'dashboard' :<House />
  };

  const items = menuItem?.rc.map((item: any, i: number) => {
    // Check for specific URLs and return only the item
    const specificUrls = [
      'management-report',
      'documents',
      'legal-documents',
      'user-management',
    ];
    if (specificUrls.includes(item?.Url)) {
      return {
        key: i,
        icon: iconMap[item?.Url] || <Folder />, // Placeholder for the icon
        label: <NavLink to={item?.Url}>{item?.Name}</NavLink>,
      };
    }

    if (item?.SubMenu?.length) {
      return {
        key: i,
        icon: <Folder />, // Placeholder for the icon
        label: <NavLink to={item?.Url}>{item?.Name}</NavLink>,
        children: item.SubMenu.map((child: any) => ({
          key: child.Id,
          label: <NavLink to={child.Url}>{child.Name || ''}</NavLink>,
        })),
      };
    } else {
      return {
        key: i,
        icon: <House />,
        label: <NavLink to={item?.Url}>{item?.Name}</NavLink>,
      };
    }
  });

  return (
    <>
      <SideBarWrapper className='sidebarl'>
        <Sider
          id='sideBar'
          data-testid='side-bar'
          breakpoint='lg'
          // collapsible
          collapsed={collapsed}
          collapsedWidth={isMobile ? '0' : '48'}
          width={isMobile ? 260 : 250}
          onCollapse={toggleCollapsed}
          className='side-bar-sider select-none'
        >
          <StyledMenu
            selectedKeys={activeKeys}
            defaultOpenKeys={!collapsed ? activeKeys : undefined}
            mode='inline'
            items={items}
            className='side-bar-menu'
          />
        </Sider>
      </SideBarWrapper>
    </>
  );
};
